import * as React from "react";
import Box from "@mui/material/Box";
import Slider, { SliderThumb } from "@mui/material/Slider";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import _, { debounce } from "lodash";
import { useField, useFormik } from "formik";
function valuetext(value: number) {
  return `${value}°C`;
}

interface IRangeSlider{
    value: number;
    onChange?: (st: any) => void;
    name: string;
    min: number;
    max: number;
    defaultValue: number;
    initialPaymentPercent: number;
}

export default function RangeSlider(props: IRangeSlider) {
  const [field, meta, helpers] = useField({name: props.name});
  const [values, setValue] = React.useState<number>(props.defaultValue);
  const debounceHandle = (event: Event, newValue: number | number[]) => {
    // props.onChange(newValue as number);
  };
  const debouncedChangeHandler = React.useCallback(
    debounce(debounceHandle, 100),
    []
  );

  // sleep()
  
  const handleChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number);
    helpers.setValue(newValue);
    debouncedChangeHandler(event, newValue);
  };
  
  return (
    <Content>
      <CustomSlider
        name={props.name}
        value={values}
        onChange={handleChange}
        valueLabelDisplay="auto"
        min={props.min}
        max={props.max}
        components={{
          Thumb: (e: any) => (<ThumbComponent {...e}  percent={props.initialPaymentPercent} />),
        }}
        getAriaValueText={valuetext}
      />
    </Content>
  );
}

function ThumbComponent(props: any) {
    const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <Thumblabel>{props.percent + '%'}</Thumblabel>
      {/* <ThumbIconLeft />
      <ThumbIconRight /> */}
    </SliderThumb>
  );
}
const Content = styled(Box)`
  width: 100%;
`;
const shareStylesThumbIcon = css`
  width: 9px;
  height: 9px;
  color: #fff;
  font-weight: bold;
`;
const ThumbIconLeft = styled(ArrowBackIosNewRoundedIcon)`
  ${shareStylesThumbIcon}
`;
const ThumbIconRight = styled(ArrowForwardIosRoundedIcon)`
  ${shareStylesThumbIcon}
`;
const shareStylesContent = css`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const Thumblabel = styled.span`
    color: #fff;
    font-weight: bold;
    font-size: 10px;
    display: block;
    text-align: center;
`
const ContentDescription = styled(Box)`
  ${shareStylesContent}
`;
const LabelDescription = styled.span`
  color: var(--color-brand-grey-main);
  font-size: 14px;
`;
const ContentValue = styled(Box)`
  margin-top: 5px;
  ${shareStylesContent}
`;
const LabelValue = styled.span`
  color: var(--color-brand-blue-main);
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
`;
const LabelValuePrice = styled.span`
  color: var(--color-brand-blue-main);
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
`;
const CustomSlider = styled(Slider)`
& .MuiSlider-rail {
    color: var(--color-brand-grey-secondary);
    height: 9px;
  }
  & .MuiSlider-track {
    background-color: var(--color-brand-red-main);
    border-color: var(--color-brand-red-main);
    height: 8px;
  }
  & .MuiSlider-thumb {
    pointer-events: none;
    height: 40px;
    width: 40px;
    background-color: var(--color-brand-red-main);
    border: "none";
    outline: 8px solid #fff;
    color: #000;
    &:hover,
    &:active {
      // boxShadow: 0 0 0 8px rgba(58, 133, 137, 0.16);
      box-shadow: none;
    }
    & .MuiSlider-valueLabel {
      display: none;
    }
  }
`;